import { useLocation } from 'react-router-dom';

export interface ITemplateConfigureParams {
  templateId: string | null;
}

export const useTemplateConfigureParams =
  (): ITemplateConfigureParams | null => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    if (queryParams.get('isTemplate') !== 'true') {
      return null;
    }
    return { templateId: queryParams.get('templateId') };
  };

export const useAllowIncompleteAnswers = (): boolean =>
  !!useTemplateConfigureParams();
